import React from 'react';
import PropTypes from 'react-proptypes';
import { cssInJS } from '../utils/styles';

export default class ProgressBar extends React.Component {
  static propTypes = {
    progress: PropTypes.number,
  };

  render() {
    // @ts-ignore
    const { styles } = ProgressBar;
    // @ts-ignore
    let progress = +this.props.progress;

    if (isNaN(progress)) {
      progress = 0;
    }

    progress = Math.max(0, Math.min(progress, 100));

    const style = {
      width: `${progress}%`,
      transition: 'width 300ms',
    };

    return (
      <div className={css(styles.container)}>
        <div
          className={css(styles.progress)}
          style={style}
        />
      </div>
    );
  }
}

const styles = cssInJS({
  container: {
    borderRadius: 3,
    // @ts-ignore
    border: `2px solid ${THEME.linkColor}`,
  },

  progress: {
    height: 20,
    // @ts-ignore
    backgroundColor: THEME.linkColor,
  },
});
// @ts-ignore
ProgressBar.styles = styles;
